module.exports = __webpack_public_path__ + "media/images/home-desktop-xxl-a5a4ce4a2bc2ef5e89f97a8166e2ae0b.jpg";